import { ISchemaComponentItem } from 'components/SchemaComponent/types';
import { EStatus } from './common';

// ! types & enums
export enum EAdSectionBidStatus {
	PENDING = 'pending',
	SCHEDULED = 'scheduled',
	QUEUED = 'queued',
	IN_PROGRESS = 'in_progress',
	DEPLETED = 'depleted',
	PAUSED = 'paused',
	CANCELLED = 'cancelled',
	COMPLETED = 'completed',
}

// ! interfaces
export interface IAdSectionCompetitors {
	minimum_bid?: number;
	maximum_bid?: number;
}

export interface IAdSection {
	id: number;
}

export interface IAdSectionBid {
	id: number;
	start_date: string;
	budget: {
		spent: number;
		total: number;
	};
	price_per_click: number;
	status: EAdSectionBidStatus;
	actions: {
		can_resume: boolean;
		can_pause: boolean;
		can_cancel: boolean;
		can_edit: boolean;
	};
	ad_section: {
		id: number;
		app_component?: ISchemaComponentItem; // todo @tiago remove "?" optional
		status: EStatus;
		name: string;
	};
}

export interface IAdSectionBidCreatePayload {
	id?: number;
	ad_section_id: IAdSection['id'];
	budget: number;
	price_per_click: number;

	start_date: string;
}

export interface IAdSectionBidEditPayload extends IAdSectionBidCreatePayload {
	id: number;
}
